import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

export default class extends Controller {
  static targets = ["swiper", "next", "prev", "floatingLink"]
    static values = {
        options: Object
    }

    connect() {
        this.swiper = new Swiper(
            this.swiperTarget,
            {
                slidesPerView: 2,
                spaceBetween: 20,
                speed: 600,
                loop: false,
                pagination: false,
                navigation: {
                    nextEl: this.nextTarget
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 65,
                    }
                },
            }
        );
    }

    moveLink(event) {
        const rect = this.element.getBoundingClientRect()
        const x = event.clientX - rect.left
        const y = event.clientY - rect.top

        requestAnimationFrame(() => {
            this.floatingLinkTarget.style.left = `${x}px`
            this.floatingLinkTarget.style.top = `${y}px`
        })
    }

    showLink() {
        this.floatingLinkTarget.style.display = "inline-flex"
        this.floatingLinkTarget.style.opacity = "1"
    }

    hideLink() {
        this.floatingLinkTarget.style.opacity = "0"
        this.floatingLinkTarget.style.display = "none"
    }

    disconnect() {
        this.swiper.destroy()
    }
}